import { render } from "./FeeGeneralScheduleBlock.vue?vue&type=template&id=04b7a832&scoped=true"
import script from "./FeeGeneralScheduleBlock.vue?vue&type=script&lang=js"
export * from "./FeeGeneralScheduleBlock.vue?vue&type=script&lang=js"

import "./FeeGeneralScheduleBlock.vue?vue&type=style&index=0&id=04b7a832&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b7a832"]])

export default __exports__